(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const loadHover = (slot) => {
      if (!slot || slot.dataset.loaded) return;
      slot.dataset.loaded = 'true';
      const img = document.createElement('img');
      img.className = 'product-card__image product-card__image--hover';
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.src = slot.dataset.src;
      img.srcset = slot.dataset.srcset;
      img.sizes = slot.dataset.sizes;
      slot.replaceWith(img);
    };

    document.addEventListener(
      'pointerenter',
      (event) => {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        const media = event.target.closest?.('.product-card__media');
        if (!media) return;
        loadHover(media.querySelector('[data-hover-image]'));
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["showroom-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-showroom-more]');
    if (!button) return;
    const extras = button.closest('[data-showroom-card]').querySelectorAll('[data-showroom-extra]');
    extras.forEach((item) => (item.hidden = false));
    button.remove();
    extras[0]?.focus();
  });
  } catch(e) { console.error(e); }
})();

})();
